module.exports = "https://s91588.cdn.ngenix.net/microcredits-frontend/_next/static/images/mainWinnerMale-96c0b320b39b8564191590c932918b86.png";